module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/maintain-report/maintain-report-home/maintain-report-home.component.html
// module id = ../../../../../src/app/features/reports/maintain-report/maintain-report-home/maintain-report-home.component.html
// module chunks = main